import { Link } from "react-router";

const formatCount = (value: number | null | undefined) => value?.toLocaleString() ?? "-";

export const getFunnelPercent = (value: number | undefined, total: number | undefined): string | undefined => {
  if (!total || value === undefined) {
    return undefined;
  }

  return `${((value / total) * 100).toFixed(1)}%`;
};

export type FunnelCard = {
  label: string;
  value: number | undefined;
  percent?: string;
  isError?: boolean;
};

const RowsFunnel = ({ cards, recordsPath }: { cards: FunnelCard[]; recordsPath: string }) => (
  <div className="mb-6 flex items-stretch gap-2">
    {cards.map((card) => (
      <Link
        key={card.label}
        to={`${recordsPath}?has_error=${card.isError ? "true" : ""}`}
        className="
          min-w-0 flex-1 rounded-md border border-stone-200 bg-white px-4 py-3
          hover:bg-stone-50
        "
      >
        <div className="text-sm text-stone-600">{card.label}</div>
        <div className="mt-1 flex items-baseline gap-2">
          <span
            className={`
              text-2xl font-semibold
              ${card.isError && card.value ? "text-red-600" : "text-stone-900"}
            `}
          >
            {formatCount(card.value)}
          </span>
          {card.percent && <span className="text-xs text-stone-500">{card.percent}</span>}
        </div>
      </Link>
    ))}
  </div>
);

export default RowsFunnel;
